<template>
    <el-dialog
        :visible.sync="show"
        title="选择试卷"
        :lock-scroll="false"
        custom-class="m-dialog"
    >
        <el-form :model="query" :inline="true">
            <el-form-item label="试卷分类" prop="Category">
                <medical-class-selector v-model="query.Category"></medical-class-selector>
            </el-form-item>
            <el-form-item label="试卷用途" prop="Category">
                <el-select v-model="query.use" placeholder="试卷用途" clearable>
                    <el-option
                        v-for="item in uesList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="关键字">
                <el-input v-model="query.name" placeholder="请输入搜索关键字"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button @click="loadData" type="primary">查找</el-button>
            </el-form-item>
        </el-form>
        <el-table :data="list" border style="width: 100%;margin-top: 10px"
                  v-loading="loading"
                  row-key="ExamPaperId"
                  ref="table"
                  @selection-change="handleSelectionChange">
            <el-table-column
                type="selection"
                reserve-selection
                :selectable="selectable"
                width="55">
            </el-table-column>
            <el-table-column
                prop="ExamName"
                label="试卷名称"
                width="300">
            </el-table-column>
            <el-table-column
                prop="SubjectNum"
                label="题量">
            </el-table-column>
            <el-table-column
                prop="TotalScore"
                label="总分">
            </el-table-column>
            <el-table-column
                prop="PassScore"
                label="及格分">
            </el-table-column>
            <el-table-column label="用途" width="150">
                <template v-slot="scope">
                    {{getUse(scope.row.ExamUse)}}
                </template>
            </el-table-column>
        </el-table>
        <div class="xy-center" style="margin-top: 10px">
            <el-pagination
                @current-change="loadData()"
                @size-change="loadData(true)"
                :current-page.sync="query.pageNo"
                :page-size.sync="query.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="show = false">取 消</el-button>
            <el-button type="primary" @click="sureSelect">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
// 选择试卷 选择后通过 result 事件通知
import MedicalClassSelector from "@/components/manager/MedicalClassSelector";
import { fetchPaperList } from "@/api/manage";
import { cleanNoneParam } from "@/utils";

export default {
    name: "SelectPaperDialog",
    components: { MedicalClassSelector },
    props: {
        defaultSelected: {
            type: Array,
            default() {
                return []
            }
        },
        maxSelect: {
            type: Number
        }
    },
    data() {
        return {
            show: false,
            list: [],
            loading: false,
            query: {
                name: "",
                Category: "",
                use: "",
                pageNo: 1,
                pageSize: 10
            },
            total: 0,
            inputSelect: []
        }
    },
    computed: {
        uesList() {
            return [
                { value: "", label: "全部" },
                { value: "1", label: "考试" },
                { value: "2", label: "作业" },
                { value: "3", label: "前台学生练习" }
            ]
        }
    },
    methods: {
        open() {
            this.show = true;
            this.inputSelect = Array.from(this.defaultSelected)
            this.loadData(true);
        },
        handleSelectionChange(list) {
            if (this.maxSelect && list.length > this.maxSelect) {
                this.limitFn(list);
                return;
            }
            this.inputSelect = [...list];
        },
        // 限制数量方法
        limitFn(list) {
            this.$refs.table.clearSelection(); // 用于多选表格，清空用户的选择
            for (let i = 0; i < this.maxSelect; i++) {
                this.$refs.table.toggleRowSelection(list[i]); // 用于多选表格，切换某一行的选中状态，如果使用了第二个参数，则是设置这一行选中与否（selected 为 true 则选中）
            }
        },
        async loadData(init) {
            this.loading = true;
            if (init) {
                this.query.pageNo = 1;
            }
            let query = {
                pageNo: this.query.pageNo,
                pageSize: this.query.pageSize,
                searchKey: this.query.name,
                examUse: this.query.use
            }
            query.classId = this.query.Category
            query = cleanNoneParam(query)
            let { data } = await fetchPaperList(query)
            this.list = data.data
            this.total = data.count
            this.loading = false;
            this.$nextTick(() => {
                this.list.forEach(el => {
                    let inSelected = this.inputSelect.some(select => select.ExamPaperId === el.ExamPaperId)
                    if (inSelected) {
                        this.$refs.table.toggleRowSelection(el, true)
                    }
                })
            })
        },
        // 用户点击选中切换
        onSelect(selection, row) {
            if (this.inputSelect.length >= this.maxSelect) {
                this.$refs.table.toggleRowSelection(row, false)
            }
            let index = this.inputSelect.findIndex(el => el.ExamPaperId === row.ExamPaperId)
            if (index > -1) {
                this.inputSelect.splice(index, 1)
            } else {
                if (this.maxSelect == null) {
                    this.inputSelect.push(row)
                } else {
                    if (this.inputSelect.length < this.maxSelect) {
                        this.inputSelect.push(row)
                    } else {
                        this.$message.warning('最多选择' + this.maxSelect + '张试卷')
                    }
                }
            }
        },
        // 用户点击全选
        onSelectAll(selection) {
            console.log(selection, 'selection')
            if (selection.length > 0) {
                // 全选
                if (this.maxSelect >= 1) {
                    if (this.inputSelect.length < this.maxSelect) {
                        selection.slice(this.maxSelect, selection.length).forEach(row => {
                            this.$refs.table.toggleRowSelection(row, false)
                        })
                        selection.slice(0, this.maxSelect - this.inputSelect.length).forEach(row => {
                            let index = this.inputSelect.findIndex(el => el.ExamPaperId === row.ExamPaperId)
                            if (index < 0) {
                                this.inputSelect.push(row)
                            }
                        })
                    } else {
                        this.$refs.table.toggleAllSelection()
                    }
                } else {
                    selection.forEach(row => {
                        let index = this.inputSelect.findIndex(el => el.ExamPaperId === row.ExamPaperId)
                        if (index < 0) {
                            this.inputSelect.push(row)
                        }
                    })
                }
            } else {
                // 取消全选
                this.list.forEach(row => {
                    let index = this.inputSelect.findIndex(el => el.ExamPaperId === row.ExamPaperId)
                    if (index > -1) {
                        this.inputSelect.splice(index, 1)
                    }
                })
            }
        },
        selectable(row) {
            if (!this.maxSelect) return true
            const index = this.inputSelect.findIndex((v) => v.ExamPaperId === row.ExamPaperId)
            return this.inputSelect.length >= this.maxSelect
                ? index !== -1
                : true;
        },
        sureSelect() {
            this.show = false;
            this.$emit("result", this.inputSelect)
        },
        getUse(use) {
            const uses = {
                1: "考试",
                2: "作业",
                3: "前台练习"
            }
            return uses[use]
        }
    }
}
</script>

<style scoped lang="less">

</style>
